const MAX_SEARCH_TEXT_LENGTH = 128
const MAX_SEARCH_TOKENS = 10
const WHITESPACE = /\s+/

interface SearchScoring {
  prefix_length: number,
  minimum_should_match: string,
  prefix_boost: number
}

interface SearchTextConfig {
  elasticsearch: {
    searchScoring: SearchScoring
  }
}

export function boundSearchText (searchText: string): string {
  return String(searchText || '')
    .slice(0, MAX_SEARCH_TEXT_LENGTH)
    .trim()
    .split(WHITESPACE)
    .slice(0, MAX_SEARCH_TOKENS)
    .join(' ')
}

function normalizeFuzzyClause (should: any[], searchScoring: SearchScoring): boolean {
  const fuzzyClause = should.find(clause => clause.multi_match)

  if (!fuzzyClause) {
    return false
  }

  delete fuzzyClause.multi_match.cutoff_frequency
  fuzzyClause.multi_match.prefix_length = searchScoring.prefix_length
  fuzzyClause.multi_match.minimum_should_match = searchScoring.minimum_should_match

  return true
}

export function applySearchTextQuery (
  queryBody: Record<string, any>,
  searchText: string,
  config: SearchTextConfig
): boolean {
  const should = queryBody.query?.bool?.must?.function_score?.query?.bool?.should

  if (!Array.isArray(should)) {
    return false
  }

  const { searchScoring } = config.elasticsearch

  if (!normalizeFuzzyClause(should, searchScoring)) {
    return false
  }

  should.push({
    match_phrase_prefix: {
      name: {
        query: boundSearchText(searchText),
        boost: searchScoring.prefix_boost
      }
    }
  })

  return true
}
